import { Component, OnInit, HostListener } from '@angular/core';
import "./fbfeed.component.scss";
import { HttpClient } from '@angular/common/http';
import { trigger, style, animate, transition, state } from '@angular/animations';
import localeNn from '@angular/common/locales/nn';
import { registerLocaleData } from '@angular/common';
import { MatCarousel, MatCarouselComponent } from '@ngmodule/material-carousel';

registerLocaleData(localeNn);

@Component({
  selector: 'fbfeed-element',  
  templateUrl: './fbfeed.component.html',
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({height: '0'}),
        animate('400ms ease-in', style({height: '*'}))
      ]),
      transition(':leave', [
        animate('400ms ease-out', style({height: '0'}))
      ])
    ])
  ]
})

export class FbFeedComponent implements OnInit {

  fb: any = false;
  fbError: boolean = false;
  limit: number = 1;
  autoFetchTimer: any;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.fetchFb();
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
      this.fetchFb();
  }

  fetchFb() {
    this.http.get("/api/facebook").subscribe(
      (fb) => {
        if (fb['posts']) {
          if (!this.fb)
            this.fb = fb;
          else if (this.fb['checksum'] != fb['checksum']) 
            this.fb = fb;
          else 
            this.fbError = false;
        } else {
          this.fbError = true;
        }
      },
      
      (error) => {
          console.log(error);
          this.fbError = true;
    });

    if (this.autoFetchTimer) {
      clearTimeout(this.autoFetchTimer); 
      this.autoFetchTimer = null;
    }

    this.autoFetchTimer = setTimeout( () => this.fetchFb(), 1000*60*15);
  
  }

  more() {
    this.limit = this.limit + 1;
  }

}